import { Feature, Map } from "ol";
import GeometryType from "ol/geom/GeometryType";
import Point from "ol/geom/Point";
import { Draw } from "ol/interaction";
import VectorLayer from "ol/layer/Vector";
import { Icon, Style } from "ol/style";
import React from "react";

type UseDrawProps = {
  map: Map | undefined;
  enabled?: boolean;
  coordinates?: number[];
  drawType?: GeometryType;
  drawLayer: VectorLayer;
  drawIcon?: string;
};

// type Return = {
//   drawLayer: Layer<Source> | undefined;
//   setItemCoordinates: React.Dispatch<React.SetStateAction<number[]>>;
//   itemCoordinates: number[];
// };

export function getPoiSvgStyle(icon: string | undefined) {
  return new Style({
    image: new Icon({
      src: `${window.location.origin}${icon}`,
      scale: 1.5,
    }),
  });
}

export const useDraw = ({
  map,
  coordinates = [],
  enabled = true,
  drawType = GeometryType.POINT,
  drawLayer,
  drawIcon,
}: UseDrawProps) => {
  const [itemCoordinates, setItemCoordinates] =
    React.useState<number[]>(coordinates);

  // TODO COMBINE
  React.useEffect(() => {
    if (drawType !== GeometryType.POINT) return;
    const source = drawLayer?.getSource();
    if (!source) return;
    const poiFeature = source.getFeatures()[0];
    if (!poiFeature) {
      source.addFeature(new Feature({ geometry: new Point(itemCoordinates) }));
    } else {
      const geometry = new Point(itemCoordinates);
      poiFeature.setGeometry(geometry);
    }
  }, [drawLayer, drawType, itemCoordinates]);

  React.useEffect(() => {
    const source = drawLayer?.getSource();
    if (!map || !source || !enabled) return;

    const draw = new Draw({
      source,
      type: drawType,
      style: drawIcon ? getPoiSvgStyle(drawIcon) : undefined,
    });

    map?.addInteraction(draw);

    draw.on("drawstart", () => {
      source.clear();
    });

    draw.on("drawend", (e) => {
      const c = (e.feature.getGeometry() as Point).getCoordinates();
      if (!c) return;
      setItemCoordinates(c);
    });
    // eslint-disable-next-line consistent-return
    return () => {
      map.removeInteraction(draw);
    };
  }, [drawLayer, drawType, enabled, map, drawIcon, itemCoordinates.length]);

  const clearDrawing = React.useCallback(() => {
    const source = drawLayer?.getSource();
    if (!source) return;
    setItemCoordinates([]);
    source.clear();
  }, [drawLayer]);

  return {
    drawLayer,
    clearDrawing,
    setItemCoordinates,
    itemCoordinates,
  };
};
